export const activeStatusReportOptions = [
  {
    id: true,
    name: 'Activo',
  },
  {
    id: false,
    name: 'Inactivo',
  },
];